import { SlideEffect } from '../../types';

export const DEFAULT_IMAGE_EFFECT: SlideEffect = {
  effect: 'none',
};
